import { CharacterPartType } from "../../../dto/CharacterPartDTO";
import PiBasicQuizCheckboxV2 from "../components/v2/PiQuizCheckboxV2";

export default function CharacterPartSelectionList(props: {
  selectedParts: CharacterPartType[];
  onToggleCharacterPart: (part: CharacterPartType, toggled: boolean) => void;
}) {
  const mapped = Object.keys(CharacterPartType)
    .filter((key) => isNaN(Number(key)) && key !== "None")
    .map((key) => {
      return (
        <div className="w-full h-[52px]" key={key}>
          <div className="flex flex-row items-center w-full h-full gap-[12px]">
            <PiBasicQuizCheckboxV2
              checked={props.selectedParts.includes(
                CharacterPartType[key as keyof typeof CharacterPartType]
              )}
              onChange={(toggled) =>
                props.onToggleCharacterPart(
                  CharacterPartType[key as keyof typeof CharacterPartType],
                  toggled
                )
              }
              square
              size="small"
              variant="interaction-blue"
            />
            <div className="text-interaction-primary text-[14px]">{key}</div>
          </div>
        </div>
      );
    });

  return (
    <div className="grid grid-cols-4 gap-y-[12px] w-full h-auto py-[12px] px-[48px] bg-interaction-softBackground rounded-[5px]">
      {mapped}
    </div>
  );
}
